export default class hr {
	static translations = {
		labels: {
			logout: "Odjava",
			profile: "Profil",
			yourData: "Vaši podaci",
			rowsPerPage: "Redaka po stranici:",
			all: "Svi",
			noResults: "Nema rezultata.",
			of: "od",
			from: 'od',
			to: 'do',
			uploadInProgress: 'Slanje u tijeku.',
			new: "Novo",
			dragdrop: "Povucite datoteke ovdje",
			dragdropSingle: "Povucite datoteku ovdje",
			selectBuilding: "Odaberite zgradu kako bi ju pridružili korisniku",
			addSpacesWithTab: "Unesite šifru prostora i stisnite \"TAB\"",
			enterNewPassword: "Unesite novu lozinku"
		},
		modules: {
			login: "Prijava",
			dashboard: "Kontrolna ploča",
			profile: "Moj profil",
			userAccounts: "Korisnički računi",
			newUserAccount: "Novi korisnički račun",
			buildings: "Zgrade",
			newBuilding: "Nova zgrada",
			reports: "Izvještaji"
		},
		fields: {
			search: 'Pretraga',
			firstName: 'Ime',
			lastName: 'Prezime',
			username: 'Korisničko ime',
			password: 'Lozinka',
			rememberMe: 'Zapamti prijavu',
			passwordChange: "Promjena lozinke",
			oldPassword: "Stara lozinka",
			newPassword: "Nova lozinka",
			newPasswordConfirmation: "Ponovljena nova lozinka",
			active: "Aktivno",
			role: "Uloga",
			code: "Šifra",
			streetAndNo: "Ulica i kućni broj",
			postalCode: "Poštanski broj",
			city: "Grad",
			country: "Država",
			manager: "Upravitelj",
			spaces: "Prostori",
			building: "Zgrada"
		},
		alerts: {
			deletionQuestion: "Jeste li sigurni da želite izbrisati ovaj zapis?",
			fileDeletionQuestion: "Jeste li sigurni da želite izbrisati ovu datoteku?",
			photoDeletionQuestion: "Jeste li sigurni da želite izbrisati ovu fotografiju?",
			firstNameMissing: "Niste unijeli ime.",
			lastNameMissing: "Niste unijeli prezime.",
			usernameMissing: "Niste unijeli korisničko ime.",
			passwordMissing: "Niste unijeli lozinku.",
			passwordFailConfirmation: "Lozinke se ne podudaraju.",
			passwordSetSuccess: "Nova lozinka je postavljena.",
			passwordLength: "Lozinka mora imati minimalno 8 znakova.",
			loginFail: "Neispravni podaci za prijavu.",
			basicUpdate: "Promjene spremljene.",
			basicDelete: "Zapis izbrisan.",
			basicAdd: "Zapis dodan.",
			basicError: "Došlo je do greške na poslužitelju.",
			fieldMissing: "Ovo polje je obavezno",
			deleteError: "Ovaj zapis ne možete izbrisati.",
			leaveQuestion: "Jeste li sigurni da želite otići bez spremanja?",
			generatePasswordQuestion: "Jeste li sigurni da želite generirati novu lozinku ovom korisniku?",
			buildingExists: "Ta zgrada je već pridružena ovom korisniku.",
			buildingRemoveQuestion: "Jeste li sigurni da želite ukloniti pridruženu zgradu?",
			scanDone: "Novi izvještaji su učitani"
		},
		buttons: {
			login: 'Prijava',
			logout: 'Odjava',
			profile: 'Profil',
			new: "Novo",
			save: "Spremi",
			add: "Dodaj",
			cancel: "Odustani",
			yes: "Da",
			no: "Ne",
			ok: "OK",
			delete: "Briši",
			back: "Natrag",
			filter: "Filtriraj",
			cancelFilter: "Poništi filtriranje",
			all: "Sve",
			setNewPassword: "Postavi novu lozinku",
			send: "Pošalji",
			scan: "Učitaj nove izvještaje",
			close: "Zatvori"
		},
		tooltips: {
			edit: "Uredi",
			delete: "Briši",
			filter: "Filter",
			logout: "Logout",
			openInNewTab: "Otvori u novom tabu",
			excel: "Excel export"
		},
		texts: {
			passwordReset: `Ako ste zaboravili lozinku ovdje možete zatražiti slanje e-maila sa novom lozinkom.`
		},
	}
}

